<!-- MOBILE -->
@if (browserSniffer.isMobile()) {
<div (@openClose.start)="onAnimationEventStart($event)" (@openClose.done)="onAnimationEventEnd($event)"
  [ngClass]="{'active':isOpen}"
  [@openClose]="{value: isOpen ? 'open' : 'closed', params: {panelHeight: languageService.availableLanguages.length * 50}}"
  class="language-chooser">
  <mat-nav-list class="">
    @for (lang of languageService.availableLanguages; track lang; let i = $index) {
    <mat-list-item mat-list-item class="lang-list lang-list-item "
      [class.selected]="lang === languageService.selectedLang()" (click)="setSelectElement(lang)">
      {{ languageService.languages[lang] }}
    </mat-list-item>
    }
  </mat-nav-list>
</div>
}

<!-- DESKTOP -->
<div style="display: contents;">
  <mat-menu #menu="matMenu" yPosition="below">
    @if (!browserSniffer.isMobile()) {
    @for (lang of languageService.availableLanguages; track lang) {
    <button mat-menu-item [ngClass]="languageService.selectedLang() === lang ? 'active':''"
      (click)="onSwitchLanguage(lang)">
      <span>{{languageService.languages[lang]}}</span>
    </button>
    }
    }
  </mat-menu>
</div>